import { RoleGate } from "@/components/gate/RoleGate";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { SystemRole } from "@/lib/consts";

import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, LinkProps, useMatchRoute } from "@tanstack/react-router";

export function SidebarContentAdmin({
  title,
  settings,
  ...rest
}: {
  title: string;
  settings: {
    name: string;
    link: LinkProps;
    icon: IconDefinition;
    systemRole?: SystemRole;
    disabled?: boolean;
    onClick?: () => void;
  }[];
}) {
  const { open } = useSidebar();
  const matchRoute = useMatchRoute();

  return (
    <SidebarGroup {...rest}>
      <SidebarGroupLabel className="text-accent font-bold uppercase group-data-[collapsible=icon]:hidden">
        {title}
      </SidebarGroupLabel>
      <SidebarMenu>
        {settings.map((item) => {
          const component = (
            <SidebarMenuItem key={item.name}>
              <SidebarMenuButton
                asChild
                isActive={!!matchRoute(item.link)}
                tooltip={item.name}
                disabled={item.disabled}
              >
                <Link {...item.link} onClick={item.onClick}>
                  <FontAwesomeIcon icon={item.icon} />
                  {open && <span>{item.name}</span>}
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          );

          if (item.systemRole) {
            return (
              <RoleGate key={item.name} systemRoles={item.systemRole}>
                {component}
              </RoleGate>
            );
          }
          return component;
        })}
      </SidebarMenu>
    </SidebarGroup>
  );
}
